<template>
    <modal
        :show="show"
        :max-width="maxWidth"
        :closeable="closeable"
        :position-modal="positionModal"
        :animation="animation"
        @close="close"
    >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
                <div
                    class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full"
                    :class="widthContent"
                >
                    <h3 class="text-lg">
                        <slot name="title"></slot>
                    </h3>

                    <div
                        class="mt-2"
                        :class="scroll ? 'overflow-y-scroll' : ''"
                    >
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="px-6 py-4 text-right"
            :class="{ 'bg-gray-100': !noBgFooter }"
        >
            <slot name="footer"> </slot>
        </div>
    </modal>
</template>

<script>
import Modal from "./Modal.vue";

export default {
    components: {
        Modal
    },

    props: {
        show: {
            default: false
        },
        maxWidth: {
            default: "2xl"
        },
        closeable: {
            default: true
        },
        scroll: {
            default: true
        },
        noBgFooter: {
            default: false
        },
        widthContent: {
            default: ""
        },
        position: {
            default: ""
        },
        positionModal: {
            default: ""
        },
        animation: {
            default: 'fade'
        }
    },

    methods: {
        close() {
            this.$emit("close");
        }
    }
};
</script>
